import { Button, Stack, Tab, Tabs } from "@mui/material";
import useQueryParams from "src/hooks/useQueryParams";
import { DebtWarehouseImportTab, DebtWarehouseRemovedTab, DebtWarehouseTab, DebtWarehouseHistoryTab } from "./Tabs";
import { useState } from "react";
import DateRangePicker from "src/components/shared/DateRangePicker";
import ExportIcon from "src/components/shared/icon/ExportIcon";

const debtWarehouseTab = [
  {
    id: "internal-import",
    name: "Nhập/ Xuất nội bộ",
  },
  {
    id: "debt-removed",
    name: "Công nợ hàng xuất bỏ",
  },
  {
    id: "debt-warehouse",
    name: "Công nợ hàng nhập kho",
  },
  {
    id: "payment-history",
    name: "Lịch sử thanh toán công nợ",
  },
];

function CustomTabPanel(props) {
  const { children, value, id, ...other } = props;

  return <>{value === id && children}</>;
}

const DebtWarehouseList = () => {
  const [option, setOption] = useQueryParams();
  const [date, setDate] = useState({ fromDate: null, toDate: null });

  const handleGetValue = (_, value) => {
    setOption({
      ...option,
      subTab: value,
    });
  };

  return (
    <>
      <Stack
        direction="row"
        justifyContent="flex-end"
        gap={2}
        mt="24px"
      >
        <DateRangePicker
          value={date}
          onApply={setDate}
          label="Thời gian phát sinh CNK"
        />
        <Button
          variant="contained"
          startIcon={<ExportIcon />}
        >
          Xuất File
        </Button>
      </Stack>
      {!option?.status && (
        <Tabs
          value={option?.subTab}
          onChange={handleGetValue}
          variant="scrollable"
          scrollButtons="auto"
          sx={{ borderBottom: "1px solid var(--grey)" }}
        >
          {debtWarehouseTab.map((v) => {
            return (
              <Tab
                value={v.id}
                sx={{
                  p: "4px 16px !important",
                  borderBottom: option?.subTab === v?.id ? "2px solid" : "",
                }}
                key={v.id}
                label={v.name}
              />
            );
          })}
        </Tabs>
      )}
      <CustomTabPanel
        value={option.subTab}
        id={debtWarehouseTab[0].id}
      >
        <DebtWarehouseTab date={date} />
      </CustomTabPanel>
      <CustomTabPanel
        value={option.subTab}
        id={debtWarehouseTab[1].id}
      >
        <DebtWarehouseRemovedTab date={date} />
      </CustomTabPanel>
      <CustomTabPanel
        value={option.subTab}
        id={debtWarehouseTab[2].id}
      >
        <DebtWarehouseImportTab date={date} />
      </CustomTabPanel>
      <CustomTabPanel
        value={option.subTab}
        id={debtWarehouseTab[3].id}
      >
        <DebtWarehouseHistoryTab date={date} />
      </CustomTabPanel>
    </>
  );
};

export default DebtWarehouseList;
